import script from "./ProductHardCenter.vue?vue&type=script&setup=true&name=ProductHardCenter&lang=js"
export * from "./ProductHardCenter.vue?vue&type=script&setup=true&name=ProductHardCenter&lang=js"

import "./ProductHardCenter.vue?vue&type=style&index=0&id=c8977b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8977b64"]])

export default __exports__